import { Entity } from "../../common/entity";
import { z } from "zod";
export const ForgeProjectArtifactRoom = Entity.extend({
    artifactId: z.string(),
    projectId: z.string(),
    liveblocksId: z.string(),
    isDirty: z.boolean(),
});
